// extracted by mini-css-extract-plugin
export default {"CourseFourmHolder":"ForumCourseList_CourseFourmHolder__nCBEX","InfoHolder":"ForumCourseList_InfoHolder__WOGMf"};